import req from '../http';
import urls from '../../utils/config';
const baseURL = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_URL: urls['url']
const marketUrl = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_MARKETURL: urls['marketUrl']

export const getUnUseCoupon = params => req('post', '/coupon/carOwnerCoupon/getUnUseCoupon', params); // 获取出行券列表
export const getOrderDetailByOrderId = params => req('post', '/carOrder/carOwner/getOrderDetailByOrderId', params); // 查看订单详情
export const getChargingCityDetail = params => req('post', '/valuation/getChargingCityDetail', params); // 获取城市规则报价端口8601
export const getCityInfo = params => req('post', '/carOrder/carOwner/getCityInfo', params); // 根据cityCode获取城市信息
export const getMyInfo = params => req('post', '/driver/info/getMyInfo', params, {
  baseURL
}); // 用于获取城市规则报价userType值端口8501
export const getChargingCityDetailCar = params => req('post', '/valuation/getChargingCityDetail', params, {
  baseURL
}); // 获取城市规则报价端口8501

export const findExpenseByOrderId = params => req('post', '/carOrder/carOwner/findExpenseByOrderId', params); // 订单费用信息查询
export const changeInitiatePayment = params => req('post', '/carOrder/carOwner/changeInitiatePayment', params); // 发起支付前锁定优惠券及计算金额接口（只做查询使用）
export const getCouponCode = params => req('post', '/client/activity/publicity/getCouponCode', params, {
  baseURL: marketUrl
}); // 兑换优惠券
//e代驾的费用明细
export const getWaitPayInfo = params => req('post', '/driving/order/getWaitPayInfo', params); // 费用明细

//操作系统
export const tutorial = params => req('post', '/config/common/tutorial', params,{
  baseURL
});
//催款进度
export const getPressList = params => req('post', '/driver/press/getPressList', params, {
  baseURL
});

// e代驾计价规则环境域名
export const e_prive_url = window.location.origin != 'https://designated.wsecar.com' ? 'h5.d.edaijia.cn' : 'h5.edaijia.cn'

